<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="clientContracts"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button
            type="success"
            :disabled="!selection.length"
            :loading="returnFlagLoading"
            @click="attachReturnFlag()">
          原件寄回
        </el-button>
        <el-button type="primary" :disabled="!selection.length" @click="onHandleContractPreview('/salesContractPrint')">
          产品销售合同
        </el-button>
        <el-button
            type="primary"
            :disabled="!selection.length"
            @click="onHandleContractPreview('/sparePartAgreementPrint')">
          备品协议
        </el-button>
        <el-button type="primary" :disabled="!selection.length" @click="onHandleContractPreview('/salesOrderPrint')">
          渠道商订单
        </el-button>
        <el-button
            type="primary"
            :disabled="!selection.length"
            @click="onHandleContractPreview('/productSalesContractPrint')">
          产品销售框架合同
        </el-button>
        <el-button
            type="primary"
            :disabled="!selection.length"
            @click="onHandleContractPreview('/trialAgreementPrint')">
          试用协议
        </el-button>
        <el-upload
            v-if="limits.importAuth"
            action=""
            :http-request="importFile"
            :show-file-list="false"
            style="float: left; margin-right: 4px;">
          <el-button type="primary" :loading="importLoading">导入模板</el-button>
        </el-upload>
        <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="downloadModel">
          模板下载
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="合同类型" prop="clientContractType">
            <el-select v-model="filter.clientContractType" clearable>
              <el-option label="渠道商协议" :value="10"/>
              <el-option label="框架合同" :value="20"/>
              <el-option label="产品销售合同" :value="30"/>
              <el-option label="产品借用转销售合同" :value="40"/>
              <el-option label="试用协议" :value="50"/>
              <el-option label="备品协议" :value="60"/>
            </el-select>
          </el-form-item>
          <el-form-item label="合同状态" prop="clientContractType" clearable>
            <el-select v-model="filter.status">
              <el-option label="草稿" :value="0"/>
              <el-option label="已提交" :value="1"/>
              <el-option label="已审批" :value="3"/>
              <el-option label="驳回" :value="4"/>
            </el-select>
          </el-form-item>
          <el-form-item label="合同编号" prop="clientContractNo">
            <el-input v-model="filter.clientContractNo" clearable/>
          </el-form-item>
          <el-form-item label="客户编号" prop="customerNo">
            <el-input v-model="filter.customerNo" clearable/>
          </el-form-item>
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="filter.customerName" clearable/>
          </el-form-item>
          <el-form-item label="创建人" prop="creatorName">
            <el-input v-model="filter.creatorName" clearable/>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
          </el-form-item>
          <el-form-item label="提交日期">
            <el-date-picker
                v-model="submitTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('submitTimeRange', 'submitTimeBegin', 'submitTimeEnd')"/>
          </el-form-item>
          <el-form-item label="通过日期">
            <el-date-picker
                v-model="passTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('passTimeRange', 'passTimeBegin', 'passTimeEnd')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            type="success"
            :disabled="scope.row.status===3 || scope.row.status===1"
            :loading="submitLoading"
            @click="submit(scope.row)">
          提交
        </el-button>
        <el-button
            v-if="limits.rejectAuth"
            type="primary"
            :loading="rejectLoading"
            @click="reject(scope.row)">
          驳回
        </el-button>
        <el-button
            v-if="limits.passAuth"
            type="primary"
            :loading="passLoading"
            @click="pass(scope.row)">
          通过
        </el-button>
      </template>
    </viewTable>
    <client-contract-edit ref="clientContractEditPage" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ClientContractEdit from "@/views/SalesManage/SalesClientContract/ClienContractEdit";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "ClientContractList",
    components: {ClientContractEdit, viewTable},
    data() {
      return {
        submitLoading: false,
        passLoading: false,
        rejectLoading: false,
        returnFlagLoading: false,
        limits: {
          editAuth: this.$auth(292),
          addAuth: this.$auth(235),
          delAuth: this.$auth(294),
          subAuth: this.$auth(236),
          passAuth: this.$auth(65),
          rejectAuth: this.$auth(315),
          importAuth: this.$auth(38),
        },
        filter: {
          clientContractNo: "",
          customerNo: "",
          customerName: "",
          clientContractType: "",
          creatorName: "",
          status: "",
          createTimeBegin: "",
          createTimeEnd: "",
          submitTimeBegin: "",
          submitTimeEnd: "",
          passTimeBegin: "",
          passTimeEnd: "",
          available: "",
        },
        selection: [],
        materialType: [],
        createTimeRange: [],
        submitTimeRange: [],
        passTimeRange: [],
        importLoading: false,

        columnsProperty: [
          {
            key: "clientContractTypeDesc",
            width: 120,
            align: "center",
          },
          {
            key: "statusDesc",
            width: 120,
            align: "center",
          },
          {
            key: "clientContractNo",
            width: 300,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.clientContractEditPage.open(params.row, true);
                    },
                  },
                },
                params.row.clientContractNo,
              );
            },
          },
          {
            key: "customerClientContractNo",
            minWidth: 360,
            align: "center",
          },
          {
            key: "clientContractName",
            minWidth: 360,
            align: "center",
          },
          {
            key: "customerName",
            minWidth: 360,
            align: "center",
          },
          {
            key: "customerNo",
            minWidth: 150,
            align: "center",
          },
          {
            key: "urgent",
            minWidth: 100,
            align: "center",
          },
          {
            key: "clientContractDeliveryDate",
            width: 140,
          },
          {
            key: "clientContractAmount",
            width: 100,
            align: "center",
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            minWidth: 200,
          },
          {
            key: "submitTime",
            minWidth: 200,
          },
          {
            key: "passTime",
            minWidth: 200,
          },
          {
            key: "businessOperatorName",
            width: 100,
            align: "center",
          },
          {
            key: "clientContractAbstract",
            width: 120,
            align: "center",
          },
          {
            key: "signAttachFlag",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: params.row.signAttachFlag === true ? "#2d8cf0" : "#ff0000",
                    cursor: "pointer",
                  },
                },
                params.row.signAttachFlag === true ? "是" : "否",
              );
            },
          },
          {
            key: "attachReturnFlag",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: params.row.attachReturnFlag === true ? "#2d8cf0" : "#ff0000",
                    cursor: "pointer",
                  },
                },
                params.row.attachReturnFlag === true ? "是" : "否",
              );
            },
          },
          {
            key: "businessNote",
            width: 210,
            align: "center",
            render: (h, params) => {
              // 初始化原始备注值
              if (params.row.originalBusinessNote === undefined) {
                params.row.originalBusinessNote = params.row.businessNote ? params.row.businessNote.trim() : "";
              }
              return h(
                "input",
                {
                  attrs: {
                    value: params.row.businessNote || "",
                  },
                  on: {
                    input: (event) => {
                      params.row.businessNote = event.target.value;
                    },
                    keydown: (event) => {
                      if (event.keyCode === 13 || event.key === "Enter") {
                        this.updateBusinessNote(params.row);
                      }
                    },
                    blur: () => {
                      this.updateBusinessNote(params.row);
                    },
                  },
                },
                params.row.businessNote || "",
              );
            },
          },
          {
            key: "action",
            align: "center",
            width: 300,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    mounted() {
    },

    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },

      addEditHandle(row) {
        this.$refs.clientContractEditPage.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "clientContracts", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      submit(row) {
        this.submitLoading = true;
        this.$http.get("basic", `clientContracts/submitOA/${row.pkId}`).then(resp => {
          if (resp.success) {
            this.loadData();
            this.$message.success("提交成功");
            this.submitLoading = false;
          }
        }).catch(() =>
          this.submitLoading = false,
        );
      },

      reject(row) {
        this.rejectLoading = true;
        this.$http.get("basic", `clientContracts/reject/${row.pkId}`).then(resp => {
          if (resp.success) {
            this.loadData();
            this.$message.success("驳回成功");
            this.rejectLoading = false;
          }
        }).finally(() =>
          this.rejectLoading = false);
        this.rejectLoading = false;
      },

      otherAuth(row) {
        if (row.status === 0 || row.status === 4) {
          return false;
        } else {
          return true;
        }
      },

      pass(row) {
        this.passLoading = true;
        this.$http.get("basic", `clientContracts/getOaResult/${row.pkId}/1`).then(resp => {
          if (resp.success) {
            this.loadData();
            this.$message.success("提交成功");
            this.passLoading = false;
          }
        }).finally(() =>
          this.passLoading = false);
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      goto(row) {
        const routeUrl = this.$router.resolve({
          path: "/ClienContractPreview",
          query: {
            billId: row.pkId,
            $tabName: row.clientContractNo,
          },
        });
        window.open(routeUrl.href, "_blank");
      },

      onHandleContractPreview(url) {
        let pkId = "";
        if (this.selection.length === 0) {
          this.$message.warning("请选择要预览的合同");
          return;

        } else if (this.selection.length > 1) {
          this.$message.warning("只能选择一条合同进行预览");
          return;
        } else {
          pkId = this.selection[0].pkId;
        }
        const routeUrl = this.$router.resolve({
          path: url,
          query: {
            id: pkId,
          },
        });
        window.open(routeUrl.href, "_blank");
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      //导入
      importFile(params) {
        this.importLoading = true;
        let formData = new FormData();
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http.post("basic", "clientContracts/importFile/1", formData).then((res) => {
          if (res.success) {
            this.importLoading = false;
            this.loadData(1);
            this.$message.success(res.data);
          } else {
            this.importLoading = false;
            this.$message.error(res.data);
          }
        }).catch(() => {
          this.importLoading = false;
          this.$message.error("导入失败");
        });
      },

      //下载导入模板
      downloadModel() {
        window.open("/file/合同导入模版.xlsx");
      },

      attachReturnFlag() {
        this.returnFlagLoading = true;
        let ids = [];
        this.selection.forEach(item => ids.push(item.pkId));
        this.$http.post("basic", "clientContracts/updateAttachReturnFlag", ids)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("更新成功");
              this.loadData();
            }
          }).finally(() => {
            this.loadData();
            this.returnFlagLoading = false;
          });
      },

      updateBusinessNote(row) {
        let businessNote = row.businessNote.trim();
        if (!businessNote) {
          businessNote = "";
        }
        // 检查备注值是否发生变化
        if (businessNote === row.originalBusinessNote) {
          // 值未变化，不请求接口
          return;
        }
        const obj = {
          pkId: row.pkId,
          businessNote: businessNote,
        };
        // 保存当前值作为原始值
        row.originalBusinessNote = businessNote;
        this.$http.post("basic", "clientContracts/updateBusinessNote", obj)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("编辑成功");
            }
          }).catch(() => {
            this.$message.error("编辑失败");
          });
      },
    },
  };
</script>
